import { BASE_ROUTES } from 'core/common/constants';
import { useConfig, useCookieConsent } from 'core/common/hooks';
import { Drawer } from 'core/common/ui/ui-kit';
import { europeanCountries, europeanUnionCountries, Locales } from 'core/user/entities';
import { Location, LocationOption } from 'core/user/ui';
import { RenderOnlyOnClient } from '../RenderOnlyOnClient';
import {
  ButtonStyled,
  CloseButtonStyled,
  CloseIconStyled,
  ContainerStyled,
  NavLinkStyled,
} from './styled';

type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const Sidebar = ({ isOpen, onClose }: SidebarProps) => {
  const config = useConfig();
  const { toggleReconsent } = useCookieConsent();

  return (
    <>
      <Drawer open={isOpen} onClose={onClose}>
        <ContainerStyled>
          <CloseButtonStyled onClick={onClose}>
            <CloseIconStyled name="cross" />
          </CloseButtonStyled>
          <nav>
            <NavLinkStyled rel="noopener noreferrer" href={BASE_ROUTES.TECH_TERMS}>
              Terms of use
            </NavLinkStyled>
            <NavLinkStyled rel="noopener noreferrer" href={BASE_ROUTES.PRIVACY_POLICY}>
              Privacy policy
            </NavLinkStyled>
            <NavLinkStyled rel="noopener noreferrer" href={config.techLinks.fullDisclaimer}>
              Full Disclaimer
            </NavLinkStyled>
            <RenderOnlyOnClient>
              <Location>
                <LocationOption option={europeanCountries}>
                  <NavLinkStyled rel="noopener noreferrer" href={config.techLinks.impressum}>
                    Impressum
                  </NavLinkStyled>
                </LocationOption>
                <LocationOption option={Locales.OTHER}>{null}</LocationOption>
              </Location>
            </RenderOnlyOnClient>
            <NavLinkStyled rel="noopener noreferrer" href={config.techLinks.impressum}>
              Impressum
            </NavLinkStyled>
            <NavLinkStyled rel="noopener noreferrer" href={config.techLinks.legalCenter}>
              Legal Center
            </NavLinkStyled>
            <RenderOnlyOnClient>
              <Location>
                <LocationOption option={[...europeanUnionCountries, Locales.GB]}>
                  <ButtonStyled onClick={toggleReconsent}>Consent settings</ButtonStyled>
                </LocationOption>
                <LocationOption option={Locales.OTHER}>{null}</LocationOption>
              </Location>
            </RenderOnlyOnClient>
            <NavLinkStyled rel="noopener noreferrer" href={config.techLinks.faq}>
              FAQ
            </NavLinkStyled>
            <NavLinkStyled rel="noopener noreferrer" href={BASE_ROUTES.TECH_CONTACT_US}>
              Contact us
            </NavLinkStyled>
          </nav>
        </ContainerStyled>
      </Drawer>
    </>
  );
};
